import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=1a19bc22&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=js"
export * from "./NotificationItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=1a19bc22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a19bc22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a19bc22')) {
      api.createRecord('1a19bc22', component.options)
    } else {
      api.reload('1a19bc22', component.options)
    }
    module.hot.accept("./NotificationItem.vue?vue&type=template&id=1a19bc22&scoped=true", function () {
      api.rerender('1a19bc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navbar/components/NotificationItem.vue"
export default component.exports